import {put,takeLatest,call} from 'redux-saga/effects';
import * as ordersService from "../../../services/orderService";
import {
    GET_ACTIVE_ORDERS_OF_VENUE,
    GET_ACTIVE_ORDERS_OF_VENUE_SUCCESS,
    GET_ACTIVE_ORDERS_OF_VENUE_ERROR
}
    from "../../actions/order";
function* getActiveOrdersOfVenueSaga(action) {
    try {
        const data=yield call(ordersService.GetActiveOrdersOfVenue,action.payload)
        yield put({
            type: GET_ACTIVE_ORDERS_OF_VENUE_SUCCESS,
            payload: data
        });

    } catch(error) {
        yield put({
            type: GET_ACTIVE_ORDERS_OF_VENUE_ERROR,error: error.data
        });
    }
}

export function* getActiveOrdersVenueSagaWatcher() {
    yield takeLatest(GET_ACTIVE_ORDERS_OF_VENUE,getActiveOrdersOfVenueSaga);
}